import React, { useEffect } from "react";
import { ADMIN_CREDENTIAL } from "../../../constant/routeContant";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as credentialAction from "../../../redux/actions/credentialAction";
import Loader from "../../../library/common/Loader";
import { API_STATUS } from "../../../constant/constant";
import ViewAdminCredential from "../component/viewAdminCredential";

function ViewAdminCredentialContainer() {
  const dispatch = useDispatch();
  const location = useLocation();
  const credentialId = location?.state?.credentialId;

  const viewCredentialData = useSelector(
    (state) => state?.getCredentialViewDetsilsData?.data
  );

  const showLoader = useSelector(
    (state) => state?.getCredentialViewDetsilsData?.isLoading
  );
  const isSuccess = useSelector(
    (state) => state.getCredentialViewDetsilsData.status === API_STATUS.SUCCESS
  );

  useEffect(() => {
    dispatch(credentialAction.getCredentialViewDetsils(credentialId));
  }, [dispatch]);

  const dataBack = {
    title: "Back to Credential",
    route: ADMIN_CREDENTIAL,
  };

  return (
    <>
      {showLoader && <Loader />}
      {isSuccess && (
        <ViewAdminCredential
          dataBack={dataBack}
          viewCredentialData={viewCredentialData}
        />
      )}
    </>
  );
}

export default ViewAdminCredentialContainer;
